/* eslint-disable no-prototype-builtins */
import { FC, useEffect } from 'react';

import { useSession } from '@eneco/auth';
import { useApplication } from '@eneco/common/application';
import { putEnecoBeXapiSiteApiV1ProfileEmail } from '@eneco/dc-be/client';
import { useRouter } from '@eneco/next';
import { ProfileManagementLoginDetailsConfirmEmailRendering } from '@sitecore/types/ProfileManagementLoginDetailsConfirmEmail';
import { useSWRConfig } from 'swr';

import LoadingPage from '../../../../../components/LoadingSpinnerWithText';
import {
  NOTIFICATION_LOCAL_LOGIN_EMAIL_CONFIRMED,
  QUERY_PARAMETER_NOTIFICATION,
  QUERY_PARAMETER_SUCCESS,
} from '../ProfileManagementLoginDetails';

const ProfileManagementLoginDetailsConfirmEmail: FC<ProfileManagementLoginDetailsConfirmEmailRendering> = ({
  fields,
}) => {
  const router = useRouter();
  const { mutate } = useSWRConfig();

  const { searchParams } = useApplication();
  const queryParams = Object.fromEntries(searchParams);
  const { data } = useSession();

  useEffect(() => {
    if (data?.accessToken) {
      const hasConfirmationToken =
        queryParams.hasOwnProperty('sessionToken') &&
        queryParams['sessionToken'] &&
        queryParams['sessionToken'].length > 0;
      if (hasConfirmationToken) {
        putEnecoBeXapiSiteApiV1ProfileEmail({
          body: {
            sessionToken: queryParams['sessionToken'],
          },
        })
          .catch(_ => {
            router.push(
              `${fields.loginManagementConfirmEmailLink.value.href}?${QUERY_PARAMETER_SUCCESS}=false&${QUERY_PARAMETER_NOTIFICATION}=${NOTIFICATION_LOCAL_LOGIN_EMAIL_CONFIRMED}`,
            );
          })
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          .then(({ response }: any) => {
            mutate('session');
            if (response.ok) {
              router.push(
                `${fields.loginManagementConfirmEmailLink.value.href}?${QUERY_PARAMETER_SUCCESS}=true&${QUERY_PARAMETER_NOTIFICATION}=${NOTIFICATION_LOCAL_LOGIN_EMAIL_CONFIRMED}`,
              );
            } else {
              router.push(
                `${fields.loginManagementConfirmEmailLink.value.href}?${QUERY_PARAMETER_SUCCESS}=false&${QUERY_PARAMETER_NOTIFICATION}=${NOTIFICATION_LOCAL_LOGIN_EMAIL_CONFIRMED}`,
              );
            }
          });
      }
    }
  }, [queryParams, data?.accessToken]);

  return <LoadingPage text={fields.loginManagementConfirmEmailLink.value.text} />;
};

export default ProfileManagementLoginDetailsConfirmEmail;
